export const FOOTER_LINK_PROPS = {
  color: 'white',
  textAlign: 'center',
  fontSize: 'xs',
};
